import { Layout, Page } from "@fdoh/health-ui-react";
import { useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import SetBacksInspectionForm from "../Components/SetBacksInspectionForm";
import { SetBacksInspectionInput } from "../Components/SetBacksInspectionForm.types";


// TODO: Add error handling


const CreateSetBacksPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
 const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
 const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

  return applicationId ? (
   
    <Page.Container>
       <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>     
      <Page.Body>
        <Layout.Container>
          <SetBacksInspectionForm
            id="createSetBacksInspectionForm"
            title="Setbacks Inspection"
            applicationId = {applicationId ? applicationId : 0 }
            applicationInspectionId = {inspectionId? inspectionId: 0}
            action="post"
            returnPath={`/inspectionDetails/${inspectionId}`}
            
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <div>
    
  </div>;
};

export default CreateSetBacksPage;